import { Mic, Send, Square } from 'lucide-react'
import { RefObject } from 'react'

interface ChatInputProps {
  inputMessage: string
  setInputMessage: (message: string) => void
  handleSendMessage: () => void
  handleKeyPress: (e: React.KeyboardEvent) => void
  textareaRef: RefObject<HTMLTextAreaElement>
  wsConnected: boolean
  listening: boolean
  startListening: () => void
  stopListening: () => void
  isSpeechSupported: boolean
}

const ChatInput = ({
  inputMessage,
  setInputMessage,
  handleSendMessage,
  handleKeyPress,
  textareaRef,
  wsConnected,
  listening,
  startListening,
  stopListening,
  isSpeechSupported,
}: ChatInputProps) => {
  return (
    <div className='p-4 bg-[#F1F1F1]'>
      <div
        className={`
          flex w-full items-center gap-1 justify-between overflow-hidden rounded-b-xl bg-white pl-5 pr-4 pt-2 pb-7
        `}
      >
        <textarea
          ref={textareaRef}
          autoFocus
          className={`
            max-h-[120px] w-full resize-none border-none bg-white
            outline-none placeholder-black
          `}
          placeholder='Type your message here..'
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={handleKeyPress}
          rows={1}
        />
        <div className='flex items-center gap-3'>
          {!listening ? (
            <button
              onClick={isSpeechSupported ? startListening : undefined}
              className={`
                hover:opacity-80

                ${!isSpeechSupported ? `cursor-not-allowed opacity-50` : ''}
              `}
              title={!isSpeechSupported ? "Your browser doesn't support speech recognition" : 'Start voice input'}
              disabled={!isSpeechSupported}
            >
              <Mic className='text-black w-5 h-5' />
            </button>
          ) : (
            <div className='flex items-center gap-2'>
              <div className='flex items-center gap-1'>
                <div className='h-2 w-2 animate-pulse rounded-full bg-black'></div>
                <div
                  className='h-2 w-2 animate-pulse rounded-full bg-black'
                  style={{ animationDelay: '0.2s' }}
                ></div>
                <div
                  className='h-2 w-2 animate-pulse rounded-full bg-black'
                  style={{ animationDelay: '0.4s' }}
                ></div>
              </div>
              <button onClick={stopListening} className='hover:opacity-80'>
                <Square className='text-black' />
              </button>
            </div>
          )}
          <button onClick={handleSendMessage} className='hover:opacity-80' disabled={!wsConnected}>
            <Send className={`
              ${wsConnected ? 'text-black w-5 h-5 rotate-45' : 'text-gray-500 w-5 h-5 rotate-45'}
            `} />
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChatInput
